import { useEffect } from 'react';

export const SITE_NAME = 'Flux Panel by LOTGaming';

/**
 * Browser tab title for a page: "<title> — Flux Panel by LOTGaming" (or the site name alone).
 * The server already sends the same title in the HTML (server/services/seoService.js) for link
 * previews and search engines; this keeps the tab right while navigating inside the app.
 * `full`: the title is used as it is (home + About: Google reads the title after the page ran, so
 * these carry the same keyword title as the server's).
 */
export default function usePageTitle(title, full = false) {
  useEffect(() => {
    const prev = document.title;
    document.title = title ? (full ? title : `${title} - ${SITE_NAME}`) : SITE_NAME;
    return () => { document.title = prev; };
  }, [title, full]);
}
